"use strict";

exports.__esModule = true;
exports.createUuid = createUuid;
exports.generateUuid = void 0;

/**
* generate v4 uuid
* this code was preferred over a separate package to reduce file size
*
* @returns
*/
const generateUuid = () => {
  var d = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};
/**
 * returns a uuid v4 wrapped in an object with a predefined key
 *
 * @export
 * @param {*} key
 * @returns
 */


exports.generateUuid = generateUuid;

function createUuid(key) {
  return {
    [key]: generateUuid()
  };
}